// extracted by css-extract-rspack-plugin
export default {"link":"link-zWHd1N"};// extracted by css-extract-rspack-plugin
export default {"link":"link-zWHd1N"};